import script from "./dni-file-uploader.vue?vue&type=script&setup=true&lang=js"
export * from "./dni-file-uploader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__